import { isFeatureEnabled } from "PFCore/helpers/use_is_feature_enabled";
import { useIsCurrentUserPermittedTo } from "PFCore/helpers/use_is_permitted_to";
import { useCurrentAccount } from "PFCore/hooks/queries/account";
import { FeatureFlag, PermissionRule } from "PFCore/types";

export const useHasKPIsAccess = () => {
  const { data: currentAccount } = useCurrentAccount();

  const isKPIsPermitted = useIsCurrentUserPermittedTo(PermissionRule.KPIsAccess);
  const hasKPIsFeature = isFeatureEnabled(currentAccount)(FeatureFlag.EngagementKPIs);

  return hasKPIsFeature && isKPIsPermitted;
};
